module.exports = __webpack_public_path__ + "8ddea09ea491aaa091cc27a60af9cb4b.webp";